export const container = "cu2rudd";
export const grid = "gc7eirl";
export const contact = "c1ncrngf";
export const address = "aw49gj0";
export const links = "l1wxdvm0";
export const contactLink = "carotpo";
export const cookieLink = "c16xvhuc";
export const link = "l11d3ilr";
export const socialGroup = "sk2y5lg";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");